import React from "react";

function TT() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 640 400"
    >
      <defs>
        <path
          id="b"
          fill="#FFC"
          fillOpacity="0.8"
          d="M546.6 153.75l-.35-37.15-44.85-46.1-76.8-65.75L89.55 91.6l-3.1 14.15 102.3 151.9 357.85-103.9z"
        />
        <path
          id="c"
          fill="#03C"
          fillOpacity="0.8"
          d="M164.15 218.85l15.9 23.35 1.1-15.05-15.35-21-1.65 12.7z"
        />
        <path
          id="d"
          fill="#333"
          fillOpacity="0.667"
          d="M236.4 265.35l-5.05-11.25q3.45-6 .7-10.65l-19.55 6.1q2.65 8.7 10.1 8.85l7 14.8 5.2-.35 1.6-7.5z"
        />
        <path
          id="e"
          fill="#06F"
          fillOpacity="0.8"
          d="M106.2 134.35l2.4 11.95 53.15 79.3 6.75 1.2-62.3-92.45m363.5-60.3l-62.45-55.4-282 74 52.8 61.15L469.7 74.05m33.65 103.5l2.25-11.5-270.7 77.4-.05 11.85 268.5-77.75z"
        />
        <path
          id="f"
          fill="#F90"
          fillOpacity="0.667"
          d="M220.05 207.15l-5.9-7.95-1.6.15q3 4.2 6 8.7l.45 10.75 1.4-.85-.35-10.8m91.5-25.85l-5.95-7.95-1.6.1 6 8.65.5 10.75 1.35-.75-.3-10.8m-21.05-3.65l-1.65.15 6.05 8.6.45 10.75 1.45-.75-.4-10.8-5.9-7.95m-5.2 1.2l-1.65.2q2.5 3.45 6 8.6l.45 10.75 1.45-.75-.4-10.8-5.85-8m10.1-2.45l-1.55.2q3.35 4.65 6 8.6l.45 10.75 1.45-.8-.4-10.8-5.95-7.95m4.95-1.8l-1.55.1 6 8.65.45 10.75 1.35-.75-.3-10.8-5.95-7.95m10.5-2.5l-1.6.1 6 8.65.4 10.75 1.45-.75-.35-10.75-5.9-8m4.95-1.8l-1.65.05 6 8.75.45 10.7 1.45-.75-.4-10.85-5.85-7.9m-45.65 12.9l-1.55.15 6 8.6.45 10.75 1.45-.75-.4-10.8-5.95-7.95m-5.25 1.2l-1.55.2 6 8.6.5 10.75 1.4-.8-.4-10.8-5.95-7.95m10.2-2.45l-1.6.15 6.05 8.7.45 10.75 1.35-.85-.3-10.8-5.95-7.95m4.95-1.85l-1.65.2q2.5 3.45 6 8.6l.45 10.75 1.5-.8-.45-10.75-5.85-8m-26.9 7.5l6 8.7.45 10.75 1.5-.75-.45-10.85-5.85-7.9-1.65.05m6.5-1.95l-1.55.15 6 8.65.5 10.7 1.4-.75-.4-10.8-5.95-7.95m-9.8 3.15l-1.6.05q3 4.2 6 8.7l.5 10.75 1.35-.75-.3-10.9-5.95-7.85m.7 9.1l-5.95-7.95-1.55.15 6 8.7.45 10.75 1.35-.85-.3-10.8m-21-3l-1.65.15 6 8.6.45 10.75 1.45-.75-.4-10.8-5.85-7.95m9.8-3.7l-1.55.15 6 8.6.45 10.75 1.4-.75-.35-10.8-5.95-7.95m-4.95 1.9l-1.55.05 6 8.7.5 10.75 1.4-.75-.4-10.8-5.95-7.95m-10.1 3l-1.65.2q2.5 3.45 6 8.6l.45 10.75 1.5-.75-.45-10.8-5.85-8m-5.25 1.25l-1.65.1 6 8.7.5 10.75 1.45-.8-.35-10.75-5.95-8m223.7-52.75l-6-7.9-1.55.15q3.35 4.65 6 8.6l.5 10.75 1.4-.75-.35-10.85m-1-8.3l-1.65.05 6 7.75.5 9.7 1.4-.7-.4-9.75-5.85-7.05m-8.25 11.1l-6-7.95-1.55.15 6.05 8.7.45 10.75 1.4-.85-.35-10.8m-1.65-9.5l-1.6.2q3.35 4.65 6 8.6l.5 10.75 1.35-.8-.35-10.8-5.9-7.95M418 142.2l-1.55.15 6 8.7.4 10.75 1.4-.75-.3-10.9-5.95-7.95m-4.65 1.6l-1.6.1q3 4.2 6 8.7l.5 10.75 1.45-.8-.45-10.85-5.9-7.9m9.6-3.1l-1.6.15q3.35 4.65 6 8.6l.4 10.75 1.5-.75-.4-10.8-5.9-7.95m-14.85 4.35l-1.6.05 6.1 8.7.4 10.75 1.45-.75-.35-10.85-6-7.9m61.6-17l6 7.65.4 9.6 1.5-.7-.4-9.55-5.95-7.1-1.55.1m2.3 8.05l-6-7.05-1.55.1 6.05 7.7.45 9.55 1.4-.7-.35-9.6m9.85-2.45l-5.9-7h-1.6l6 7.7.4 9.55 1.45-.6-.35-9.65m-27.6-1.1q2.65 3.35 6 7.75l.5 9.6 1.45-.7-.45-9.65-5.9-7.15-1.6.15m-2 9.5l-5.9-7.2-1.6.2q3.5 4.4 6 7.75l.5 9.6 1.35-.7-.35-9.65M451 133.8l-1.65.1q2.65 3.35 6 7.75l.5 9.7 1.4-.75-.4-9.7-5.85-7.1m9.85-3.4l-1.6.15 6 7.9.45 9.95 1.4-.7-.35-10-5.9-7.3m-135.3 57.9l1.45-.85-.4-10.8-5.95-7.95-1.55.15q3 4.2 6 8.7l.45 10.75m14.25-24.85l-1.65.15 6.05 8.7.4 10.75 1.5-.75-.4-10.9-5.9-7.95m-9.25 2.5l-1.65.15 6 8.6.5 10.75 1.45-.75-.45-10.8-5.85-7.95m10.55 6.7l-5.95-7.95-1.55.15 6 8.7.45 10.75 1.35-.85-.3-10.8m-15.2-5.1l-1.55.05q3 4.2 6 8.7l.45 10.75 1.35-.75-.3-10.9-5.95-7.85m34.6.15l-5.9-7.85-1.6.05 6 8.7.45 10.75 1.4-.75-.35-10.9m-10.9-6.35l-1.6.1 6 8.65.5 10.75 1.45-.75-.45-10.8-5.9-7.95m1 8.85l-5.85-7.9-1.65.05 6 8.7.5 10.75 1.4-.75-.4-10.85m13.85-12.6l-1.6.2 6 8.6.4 10.75 1.45-.75-.35-10.8-5.9-8m-4.95 1l-1.65.05 6 8.7.5 10.75 1.4-.75-.4-10.8-5.85-7.95m38.5-10.5l-1.65.1 6 8.65.5 10.75 1.4-.75-.4-10.8-5.85-7.95m4.95-1.8l-1.6.05 6 8.7.4 10.75 1.45-.75-.35-10.9-5.9-7.85m84.15-4.45l-.35-9.55-5.9-7.1-1.6.1q2.65 3.35 6 7.75l.45 9.55 1.4-.75m3.25-.4l1.4-.65-.4-9.65-5.85-7-1.65.05 6 7.7.5 9.55m13.9-22.25l-1.65.1q2.65 3.35 6 7.75l.5 9.5 1.4-.7-.3-9.55-5.95-7.1m-9.55 2.45l-1.6.15 6 7.65.5 9.6 1.4-.7-.4-9.65-5.9-7.05m4.9-1.1l-1.6.1q2.65 3.35 6 7.75l.5 9.5 1.45-.7-.45-9.55-5.9-7.1m-9.85 2.25l-1.55.1 6 7.65.4 9.55 1.4-.7-.3-9.6-5.95-7m23.75-5.75l-1.65.1 6 7.65.5 9.55 1.4-.7-.4-9.6-5.85-7m-4.65 1.1l-1.6.05 6 7.7.5 9.55 1.35-.65-.35-9.65-5.9-7z"
        />
        <path
          id="g"
          fill="red"
          fillOpacity="0.667"
          d="M218.1 166.45l-1.95-2-4.85 1.65 2 2.35 4.8-2z"
        />
        <path
          id="h"
          fill="#FC9"
          fillOpacity="0.8"
          d="M336 156.15l-7.6-9.05-108.65 29.75 7.85 9.5 108.4-30.2m173.75-43.7l-7.9-8.75-49.6 13.2 8.35 9.9 49.15-14.35z"
        />
        <path
          id="i"
          fill="#FC9"
          fillOpacity="0.667"
          d="M545.4 154.95v-1.3l-40.65 10.75-.65-19.6-266 75.75-2.6 20.85-46.85 14.1 1.4 1.7L545.4 154.95z"
        />
        <path
          id="j"
          fill="#666"
          fillOpacity="0.667"
          d="M342.65 211.65l-.15-13-97.6 27 .1 14.45 97.65-28.45m126.5-42q.6-1.7-.4-3-1.05-1.25-3.15-1.25-2.2 0-4.1 1.25-1.9 1.25-2.6 3-.65 1.75.4 3.05 1.05 1.25 3.15 1.25 2.15 0 4.05-1.25 2-1.3 2.65-3.05m-29.85 9.2q1 1.3 3.15 1.3 2.05 0 4.05-1.3 2.05-1.3 2.6-3.05.6-1.75-.4-3-1.05-1.25-3.15-1.25-2.1 0-4.1 1.25-1.95 1.35-2.55 3-.65 1.75.4 3.05m-40.7 10.45q1.6 2.05 5.1 2.05 3.5 0 6.55-2.05 3.2-2 4.25-4.9 1-2.9-.65-4.9-1.65-2-5.1-2-3.4 0-6.6 2-3.15 2.05-4.15 4.9-1.05 2.85.6 4.9m-41.8 4.3q-1.95.55-3.25 2.35-1.25 1.75-1.1 3.85l.25 2.9q.15 2.05 1.65 3.1 1.6 1.05 3.5.55l10.7-2.8q1.9-.5 3.3-2.3 1.25-1.85 1.1-3.85l-.25-2.95q-.15-1.95-1.65-3.1-1.6-1.05-3.55-.55l-10.7 2.8M487 165q1.05 1.25 3.15 1.25 2.1 0 4.1-1.25 1.95-1.25 2.6-3.05.6-1.7-.4-3-1.05-1.25-3.15-1.25-2.2 0-4.1 1.25-1.9 1.25-2.6 3-.6 1.85.4 3.05z"
        />
        <path
          id="l"
          fill="#FFF"
          d="M59.9 9.65L50.25 0 0 14.95l9.65 9.65L59.9 9.65z"
        />
        <path
          id="o"
          fill="#333"
          fillOpacity="0.667"
          d="M205.9 277.75l10.9 10.3 3.8-14.3-.4-1.05-14.3 5.05z"
        />
        <path
          id="q"
          fill="#333"
          fillOpacity="0.667"
          d="M279.6 256.55l-7.35 13.25 15 .45-6.6-13.2-1.05-.5z"
        />
        <path
          id="s"
          fill="#333"
          fillOpacity="0.667"
          d="M366.75 229.5l-1.05-.55-7.25 13.3 15 .4-6.7-13.15z"
        />
        <path
          id="v"
          fill="#333"
          fillOpacity="0.667"
          d="M411.55 224.55l-5.6 14.1 14.9-1.45-8.2-12.25-1.1-.4z"
        />
        <path
          id="y"
          fill="#333"
          fillOpacity="0.667"
          d="M447.7 218.4l13.7-6.1-11.65-9-1.2-.05-.85 15.15z"
        />
        <path
          id="A"
          fill="#333"
          fillOpacity="0.667"
          d="M519.7 178.05l-.85.8 10.2 11.25 5.3-14.05-14.65 2z"
        />
        <path
          id="C"
          fill="#333"
          fillOpacity="0.667"
          d="M200.25 172.05l.75 15 12.6-7.65.45-1.1-13.8-6.25z"
        />
        <path
          id="E"
          fill="#333"
          fillOpacity="0.667"
          d="M481.5 191.55l-1.15.25 3 14.9 11.7-9.35-13.55-5.8z"
        />
        <path
          id="H"
          fill="#333"
          fillOpacity="0.667"
          d="M149.25 233l4.65 14.25 10.2-10.7.15-1.15-15-2.4z"
        />
        <path
          id="J"
          fill="#2EC7E2"
          d="M292.95 414.9l-8.2 10.25 100.7 29.95 7.7-10.8-100.2-29.4z"
        />
        <path
          id="K"
          fill="#2EC7E2"
          d="M418 373.05l-5.7 9.45 13.25 4.05 5.8-10-13.35-3.5z"
        />
        <path
          id="L"
          fill="#2EC7E2"
          d="M430.15 387.6l13.2 4.05 5.7-10-13.25-3.5-5.65 9.45z"
        />
        <path
          id="M"
          fill="#2EC7E2"
          d="M466.45 386.4l-13.25-3.5-5.65 9.45 13.2 4.05 5.7-10z"
        />
        <path
          id="N"
          fill="#2EC7E2"
          d="M483.85 391.25l-13.2-3.5-5.7 9.3 13.25 4.2 5.65-10z"
        />
        <path
          id="O"
          fill="#2EC7E2"
          d="M430.95 392.35l-13.4-3.55-5.5 9.35 13.2 4.15 5.7-9.95z"
        />
        <path
          id="P"
          fill="#2EC7E2"
          d="M429.05 403.25l13.1 4.2 5.8-10-13.35-3.5-5.55 9.3z"
        />
        <path
          id="Q"
          fill="#2EC7E2"
          d="M446.35 408.4l13.2 4.2 5.7-10-13.25-3.65-5.65 9.45z"
        />
        <path
          id="R"
          fill="#2EC7E2"
          d="M463.75 413.1l13.2 4.2 5.7-10-13.25-3.5-5.65 9.3z"
        />
        <path
          id="S"
          fill="#2EC7E2"
          d="M342.9 378l13.1 4.2 5.8-10-13.35-3.5-5.55 9.3z"
        />
        <path
          id="T"
          fill="#2EC7E2"
          d="M378.4 376.95l-13.2-3.5-5.7 9.3 13.25 4.2 5.65-10z"
        />
        <path
          id="U"
          fill="#2EC7E2"
          d="M376.95 387.9l13.2 4.15 5.7-10-13.4-3.5-5.5 9.35z"
        />
        <path
          id="V"
          fill="#2EC7E2"
          d="M399.9 383.7l-5.7 9.3 13.25 4.2 5.65-10-13.2-3.5z"
        />
        <path
          id="W"
          fill="#2EC7E2"
          d="M280.8 349l-5.65 9.3 13.25 4.2 5.65-10-13.25-3.5z"
        />
        <path
          id="X"
          fill="#2EC7E2"
          d="M292.15 363.45l13.25 4.2 5.65-10-13.2-3.65-5.7 9.45z"
        />
        <path
          id="Y"
          fill="#2EC7E2"
          d="M309.45 368.55l13.2 4.2 5.8-10-13.35-3.65-5.65 9.45z"
        />
        <path
          id="Z"
          fill="#2EC7E2"
          d="M325.75 373.3l13.25 4.2 5.65-10-13.2-3.5-5.7 9.3z"
        />
        <path
          id="aa"
          fill="#2EC7E2"
          d="M269.75 357.75l5.8-9.95-13.35-3.65-5.55 9.45 13.1 4.15z"
        />
        <path
          id="ab"
          fill="#2EC7E2"
          d="M416.65 403.4l-5.55 9.3 13.2 4.2 5.7-10-13.35-3.5z"
        />
        <path
          id="ac"
          fill="#2EC7E2"
          d="M428.1 417.85l13.1 4.2 5.8-10-13.35-3.5-5.55 9.3z"
        />
        <path
          id="ad"
          fill="#2EC7E2"
          d="M468.05 430.25L474 420h-.15l-22.8-6.35-5.65 9.35 22.65 7.25z"
        />
        <path
          id="ae"
          fill="#2EC7E2"
          d="M347.5 383.3l-5.55 9.45 13.1 4.05 5.8-10-13.35-3.5z"
        />
        <path
          id="af"
          fill="#2EC7E2"
          d="M377.5 391.5l-13.25-3.5-5.65 9.45 13.2 4.05 5.7-10z"
        />
        <path
          id="ag"
          fill="#2EC7E2"
          d="M376 402.6l13.2 4.05 5.7-10-13.35-3.5-5.55 9.45z"
        />
        <path
          id="ah"
          fill="#2EC7E2"
          d="M406.5 411.75l5.65-9.95-13.2-3.55-5.7 9.45 13.25 4.05z"
        />
        <path
          id="ai"
          fill="#2EC7E2"
          d="M279.85 363.6l-5.65 9.3 13.25 4.2 5.65-10-13.25-3.5z"
        />
        <path
          id="aj"
          fill="#2EC7E2"
          d="M291.2 378l13.25 4.2 5.65-10-13.35-3.5-5.55 9.3z"
        />
        <path
          id="ak"
          fill="#2EC7E2"
          d="M308.5 383.15l13.2 4.2 5.85-10-13.4-3.5-5.65 9.3z"
        />
        <path
          id="al"
          fill="#2EC7E2"
          d="M324.85 387.9l13.2 4.15 5.7-10-13.25-3.5-5.65 9.35z"
        />
        <path
          id="am"
          fill="#2EC7E2"
          d="M255.7 368.15l13.1 4.2 5.8-10-13.35-3.5-5.55 9.3z"
        />
        <path
          id="an"
          fill="#2EC7E2"
          d="M416.5 418l-5.7 9.45 13.25 4.05 5.65-10-13.2-3.5z"
        />
        <path
          id="ao"
          fill="#2EC7E2"
          d="M427.85 432.55l13.2 4.05 5.7-10-13.25-3.5-5.65 9.45z"
        />
        <path
          id="ap"
          fill="#2EC7E2"
          d="M464.15 431.75l-13.35-3.5-5.55 9.3 13.25 4.2 5.65-10z"
        />
        <path
          id="aq"
          fill="#2EC7E2"
          d="M407.85 459.7l13.1 4.2 5.8-10-13.35-3.65-5.55 9.45z"
        />
        <path
          id="ar"
          fill="#2EC7E2"
          d="M341.7 407.3l13.25 4.05 5.65-9.95-13.25-3.55-5.65 9.45z"
        />
        <path
          id="as"
          fill="#2EC7E2"
          d="M371.55 416.25l5.8-10-13.35-3.5-5.55 9.3 13.1 4.2z"
        />
        <path
          id="at"
          fill="#2EC7E2"
          d="M375.7 417.15l13.25 4.2 5.65-10-13.2-3.65-5.7 9.45z"
        />
        <path
          id="au"
          fill="#2EC7E2"
          d="M406.35 426.35l5.7-10-13.25-3.5-5.65 9.45 13.2 4.05z"
        />
        <path
          id="av"
          fill="#2EC7E2"
          d="M279.6 378.15l-5.65 9.45 13.2 4.05 5.7-10-13.25-3.5z"
        />
        <path
          id="aw"
          fill="#2EC7E2"
          d="M296.6 383.3l-5.65 9.45 13.2 4.05 5.7-10-13.25-3.5z"
        />
        <path
          id="ax"
          fill="#2EC7E2"
          d="M308.35 397.75l13.25 4.15 5.65-9.95-13.2-3.55-5.7 9.35z"
        />
        <path
          id="ay"
          fill="#2EC7E2"
          d="M324.7 402.6l13.1 4.05 5.8-10-13.35-3.5-5.55 9.45z"
        />
        <path
          id="az"
          fill="#2EC7E2"
          d="M255.45 382.75l13.2 4.2 5.7-10-13.25-3.5-5.65 9.3z"
        />
        <path
          id="aA"
          fill="#2EC7E2"
          d="M415 433.8l-5.65 9.3 13.2 4.2 5.7-10-13.25-3.5z"
        />
        <path
          id="aB"
          fill="#2EC7E2"
          d="M445.25 442.4L432 438.9l-5.65 9.3 13.25 4.2 5.65-10z"
        />
        <path
          id="aC"
          fill="#2EC7E2"
          d="M248.7 413.25l5.8-10-13.35-3.5-5.7 9.3 13.25 4.2z"
        />
        <path
          id="aD"
          fill="#2EC7E2"
          d="M252.85 413.95L266.1 418l5.8-10-13.35-3.5-5.7 9.45z"
        />
        <path
          id="aE"
          fill="#2EC7E2"
          d="M340.2 423l13.25 4.15 5.65-10-13.2-3.5-5.7 9.35z"
        />
        <path
          id="aF"
          fill="#2EC7E2"
          d="M370.05 431.9l5.8-10-13.35-3.5-5.55 9.3 13.1 4.2z"
        />
        <path
          id="aG"
          fill="#2EC7E2"
          d="M374.25 432.85l13.2 4.15 5.7-9.95-13.25-3.55-5.65 9.35z"
        />
        <path
          id="aH"
          fill="#2EC7E2"
          d="M391.65 437.95l13.25 4.2 5.65-10-13.25-3.5-5.65 9.3z"
        />
        <path
          id="aI"
          fill="#2EC7E2"
          d="M285.7 407.45l5.8-10-13.4-3.5-5.65 9.3 13.25 4.2z"
        />
        <path
          id="aJ"
          fill="#2EC7E2"
          d="M289.45 408.4l13.25 4.2 5.65-10-13.2-3.65-5.7 9.45z"
        />
        <path
          id="aK"
          fill="#2EC7E2"
          d="M306.85 413.55l13.25 4.05 5.65-9.9-13.2-3.6-5.7 9.45z"
        />
        <path
          id="aL"
          fill="#2EC7E2"
          d="M342.1 412.45l-13.2-3.5-5.7 9.3 13.25 4.2 5.65-10z"
        />
        <path
          id="aM"
          fill="#2EC7E2"
          d="M272.85 392.75l-13.25-3.65-5.65 9.45 13.25 4.2 5.65-10z"
        />
        <path
          id="a"
          fill="none"
          stroke="#FC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M177.473 87.519l64.695 69.29"
        />
        <path
          id="k"
          fill="none"
          stroke="#FC9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M479.594 109.155l15.52-3.89M374.209 138.78l17.11-5.268M175.882 88.65l13.187 7.955 57.412 77.633m.389.707l-2.51 25.277m3.676-25.7l14.141-4.35"
        />
        <path
          id="p"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M259.34 222.363l-46.192 49.69"
        />
        <path
          id="r"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M307.686 213.28l-1.731 67.82"
        />
        <path
          id="t"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M368.898 193.348l-.035.424"
        />
        <path
          id="u"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M368.51 193.772l-6.327 126.381"
        />
        <path
          id="w"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M402.367 190.096l.035.46"
        />
        <path
          id="x"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M402.049 190.556l8.093 94.61"
        />
        <path
          id="z"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M431.24 174.616l27.885 61.848"
        />
        <path
          id="B"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M485.773 151.821l63.65 23.467"
        />
        <path
          id="D"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M251.74 149.312l-67.75 3.675"
        />
        <path
          id="F"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M455.627 164.685l.318.354"
        />
        <path
          id="G"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M455.627 165.216l58.313 74.96"
        />
        <path
          id="I"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M217.106 192.11l-64.393 21.453"
        />
      </defs>
      <use
        transform="matrix(.70705 0 0 .70705 109.95 22.4) translate(-155.5 -31.65) scale(1.41432)"
        xlinkHref="#a"
      />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#b" />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#c" />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#d" />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#e" />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#f" />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#g" />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#h" />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#i" />
      <use transform="matrix(.707 0 0 .707 109.95 22.4)" xlinkHref="#j" />
      <use
        transform="matrix(.70705 0 0 .70705 109.95 22.4) translate(-155.5 -31.65) scale(1.41432)"
        xlinkHref="#k"
      />
      <g transform="translate(430 94.9) scale(.70706)">
        <mask id="m">
          <use xlinkHref="#l" />
        </mask>
        <g mask="url(#m)">
          <g transform="translate(11.35 4) matrix(-.95848 .28508 -.7071 -.7071 36.6 7.35)">
            <clipPath id="n">
              <path fill="#FFF" d="M-2 -2H32.4V11.65H-2z" />
            </clipPath>
            <text clip-path="url(#n)" writingMode="lr">
              <tspan
                x="0"
                y="8"
                fill="#33C"
                baselineShift="0%"
                fontFamily="Verdana"
                fontSize="7.95"
                fontWeight="bold"
              >
                TUTOR
              </tspan>
            </text>
          </g>
        </g>
      </g>
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#o" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#p"
      />
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#q" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#r"
      />
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#s" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#t"
      />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#u"
      />
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#v" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#w"
      />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#x"
      />
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#y" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#z"
      />
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#A" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#B"
      />
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#C" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#D"
      />
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#E" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#F"
      />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#G"
      />
      <use transform="matrix(.70676 0 0 .70676 109.95 22.4)" xlinkHref="#H" />
      <use
        transform="matrix(.70683 0 0 .70683 109.95 22.4) matrix(1.41475 0 0 1.41475 -155.55 -31.65)"
        xlinkHref="#I"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#J"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 -47.75 340.85)"
        xlinkHref="#K"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 -47.75 340.85)"
        xlinkHref="#L"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 -47.75 340.85)"
        xlinkHref="#M"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 -47.75 340.85)"
        xlinkHref="#N"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#O"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#P"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#Q"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#R"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#S"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#T"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#U"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#V"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#W"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#X"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#Y"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#Z"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aa"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ab"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ac"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ad"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ae"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#af"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ag"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ah"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ai"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aj"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ak"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#al"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#am"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#an"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ao"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ap"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aq"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ar"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#as"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#at"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#au"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#av"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aw"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ax"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#ay"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#az"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aA"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aB"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 201.75 272.85)"
        xlinkHref="#aC"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aD"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aE"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aF"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aG"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aH"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aI"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aJ"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aK"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aL"
      />
      <use
        transform="matrix(.7721 -.05652 -.03822 -.52235 57.75 312.35)"
        xlinkHref="#aM"
      />
    </svg>
  );
}

export default TT;
